export default __webpack_public_path__ + "static/media/jsrbrtable_Prtbg.9dd137d2.webp";